<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="通知类型：" prop="notice_type">
                <span>{{ transEnu(model.notice_type, "notice_type")}}</span>
            </el-form-item>
            <el-form-item label="邮箱：" prop="member_id">
                <span>{{model.email}}</span>
            </el-form-item>
            <el-form-item label="CarId：" prop="car_id">
                <span>{{model.car_id}}</span>
            </el-form-item>
            <el-form-item label="VehicleId：" prop="vehicle_id">
                <span>{{model.vehicle_id}}</span>
            </el-form-item>
            <el-form-item label="标记：" prop="sign">
                <span>{{model.sign}}</span>
            </el-form-item>
            <el-form-item label="first：" prop="first">
                <span>{{model.first}}</span>
            </el-form-item>
            <el-form-item label="keyword1：" prop="keyword1">
                <span>{{model.keyword1}}</span>
            </el-form-item>
            <el-form-item label="keyword2：" prop="keyword2">
                <span>{{model.keyword2}}</span>
            </el-form-item>
            <el-form-item label="keyword3：" prop="keyword3">
                <span>{{model.keyword3}}</span>
            </el-form-item>
            <el-form-item label="keyword4：" prop="keyword4">
                <span>{{model.keyword4}}</span>
            </el-form-item>
            <el-form-item label="keyword5：" prop="keyword4">
                <span>{{model.keyword5}}</span>
            </el-form-item>
            <el-form-item label="keyword6：" prop="keyword4">
                <span>{{model.keyword6}}</span>
            </el-form-item>
            <el-form-item label="remark：" prop="remark">
                <span>{{model.remark}}</span>
            </el-form-item>
            <el-form-item label="发生时间：" prop="send_time">
                <span>{{model.send_time}}</span>
            </el-form-item>
            <!-- <el-form-item label="是否已读：" prop="is_read">
                <span>{{model.is_read}}</span>
            </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'noticeInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                notice_type: '',
                member_id: '',
                email: '',
                car_info_id: '',
                car_id: '',
                vehicle_id: '',
                sign: '',
                first: '',
                keyword1: '',
                keyword2: '',
                keyword3: '',
                keyword4: '',
                remark: '',
                send_time: '',
                is_read: '',
            },
            getObj:{
                url:'/api/admin/notice/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['notice_type'],
        };
    },
    methods: {}
};
</script>